<template>
<div class="chapter">
<div class="inner_page">
<p class="C190_9"><strong><a id="page_v">Contents</a></strong></p><a id="page_v">
</a><p class="C146"><a id="page_v"></a><a href="#/xhtml/05_Acknowle#page_vii">Acknowledgments</a></p>
<p class="C146"><a href="#/xhtml/06_1__The_N#page_1">CHAPTER 1. The New Partisan Media Environment</a></p>
<p class="C146"><span href="#/xhtml/07_2__What#page_24" title="Link target outside of Sample">CHAPTER 2. What Do Partisan Media Actually Say?</span></p>
<p class="C146"><span href="#/xhtml/08_3__Why_D#page_50" title="Link target outside of Sample">CHAPTER 3. Why Do Partisan Media Affect Viewers?</span></p>
<p class="C146a"><span href="#/xhtml/09_4__Can_P#page_66" title="Link target outside of Sample">CHAPTER 4. Can Partisan Media Polarize?</span></p>
<p class="C193_10"><span href="#/xhtml/10_Appendix#page_92" title="Link target outside of Sample">Appendix</span></p>
<p class="C146a"><span href="#/xhtml/11_5__Do_Pa#page_94" title="Link target outside of Sample">CHAPTER 5. Do Partisan Media Make Viewers Dislike and Distrust the Opposition?</span></p>
<p class="C193_10"><span href="#/xhtml/12_Appendix#page_110" title="Link target outside of Sample">Appendix</span></p>
<p class="C146a"><span href="#/xhtml/13_6__Parti#page_111" title="Link target outside of Sample">CHAPTER 6. Partisan Media’s Electoral Effects</span></p>
<p class="C193_10"><span href="#/xhtml/14_Appendix#page_134" title="Link target outside of Sample">Appendix</span></p>
<p class="C146"><span href="#/xhtml/15_7__How_P#page_135" title="Link target outside of Sample">CHAPTER 7. How Partisan Media Matter for America</span></p>
<p class="C146"><span href="#/xhtml/16_Data_App#page_159" title="Link target outside of Sample">Data Appendix</span></p>
<p class="C146"><span href="#/xhtml/17_Notes#page_179" title="Link target outside of Sample">Notes</span></p>
<p class="C146"><span href="#/xhtml/18_Referenc#page_191" title="Link target outside of Sample">References</span></p>
<p class="C146"><span href="#/xhtml/19_Index#page_211" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?ada08c18